/**
 * @generated SignedSource<<df74f6002e1dad0738d8904356d2dbbb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type TeamDirectoryViewQuery$variables = {
  cloudId: string;
  organisationId: string;
  skipOldCheck: boolean;
  teamQuery: string;
};
export type TeamDirectoryViewQuery$data = {
  readonly hasTeam?: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "TeamSearchResponseEdge";
    } | null> | null;
  } | null;
};
export type TeamDirectoryViewQuery = {
  response: TeamDirectoryViewQuery$data;
  variables: TeamDirectoryViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organisationId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipOldCheck"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamQuery"
},
v4 = [
  {
    "condition": "skipOldCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": "hasTeam",
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          },
          {
            "kind": "Variable",
            "name": "organisationId",
            "variableName": "organisationId"
          },
          {
            "kind": "Variable",
            "name": "q",
            "variableName": "teamQuery"
          }
        ],
        "concreteType": "TeamSearchResponseConnection",
        "kind": "LinkedField",
        "name": "teamsTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "TeamSearchResponseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TeamDirectoryViewQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamDirectoryViewQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "77badf116e127fd8a74360314a546932",
    "id": null,
    "metadata": {},
    "name": "TeamDirectoryViewQuery",
    "operationKind": "query",
    "text": "query TeamDirectoryViewQuery(\n  $organisationId: String!\n  $cloudId: String!\n  $teamQuery: String!\n  $skipOldCheck: Boolean!\n) {\n  hasTeam: teamsTql(organisationId: $organisationId, cloudId: $cloudId, q: $teamQuery, first: 1) @skip(if: $skipOldCheck) {\n    edges {\n      __typename\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a91d5edfd9c26304686bae833e78d96f";

export default node;
